<template>
  <div class="col-form-label"><slot /></div>
</template>

<script>

export default {
  name: "FormStaticLabel",
}
</script>